import { Injectable } from '@angular/core';

@Injectable()
export class UserService {
  id: string;
}
